<template>
  <div :class="{ 'seo-visible-header': isSeoPage }">
    <slot />
  </div>
</template>

<script>
import StateProviderSetup from 'mixins/composition/search/StateProvider';
import { getReducedCtx } from 'mixins/composition/search/index';

export default {
  name: 'VisibleHeaderWrapper',
  setup(props, ctx) {
    const { isSeoPage, isSeaPage } = StateProviderSetup(getReducedCtx(ctx));
    return { isSeoPage, isSeaPage };
  },
};
</script>
<style lang="scss" src="@/scss/components/search/VisibleHeaderWrapper.scss" scoped clientextend></style>
